import * as React from "react";
import { Form, Formik } from "formik";
import Stack from "@mui/material/Stack";
import { SelectOneField } from "components/formikFields/SelectOneField/SelectOneField";
import Container from "@mui/material/Container";
import { UserAccount } from "gen/clients/llts";
import { SelectOption } from "@mui/base";
import { useTranslation } from "react-i18next";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

interface Props {
  userAccount: UserAccount;
  organizationOptions: SelectOption<string>[];
  onSelect: (clientId: string) => void;
  onCancel: () => void;
}

const OrganizationSelector: React.FC<Props> = ({ userAccount, organizationOptions, onSelect, onCancel }) => {
  const { t } = useTranslation();

  const onSubmit = React.useCallback((values: { organization: string }) => onSelect(values.organization), [onSelect]);

  return (
    <Container maxWidth="md">
      <Formik
        initialValues={{
          organization: userAccount.clientConfig?.clientId || ""
        }}
        onSubmit={onSubmit}
      >
        <Form noValidate={true} autoComplete="off">
          <Stack sx={{ mt: 8 }} spacing={3}>
            <Typography>{t("createProject.signedInUser.organizationSelector.selectOrganization")}</Typography>
            <SelectOneField
              name="organization"
              label={t("createProject.signedInUser.organizationSelector.organization")}
              options={organizationOptions}
              required={true}
              variant="outlined"
            />
            <Stack direction="row" spacing={1} justifyContent="center">
              <Button variant="contained" type="submit" sx={{ width: 140 }}>
                {t("common.ok")}
              </Button>
              <Button onClick={onCancel}>{t("common.cancel")}</Button>
            </Stack>
          </Stack>
        </Form>
      </Formik>
    </Container>
  );
};

export { OrganizationSelector };
